module.exports = __webpack_public_path__ + "img/[打脸].092f081d.svg";